import { render, staticRenderFns } from "./info-card.vue?vue&type=template&id=5ecd0cb6&"
import script from "./info-card.vue?vue&type=script&lang=js&"
export * from "./info-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Umbraco\\Upgrade\\CareFirst\\v16\\Website\\CarersFirst.Shared.FrontEnd\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ecd0cb6')) {
      api.createRecord('5ecd0cb6', component.options)
    } else {
      api.reload('5ecd0cb6', component.options)
    }
    module.hot.accept("./info-card.vue?vue&type=template&id=5ecd0cb6&", function () {
      api.rerender('5ecd0cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/app/vue-components/common/cards/info-card.vue"
export default component.exports